import { LayoutDesktop } from '@/components/LayoutPC/LayoutDesktop'
import './DPaper.scss'
import { useRecoilState, useRecoilValue } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { PaperInfoComponent, paperState } from '../Mobile/MPaper';
import { Tracking } from '@/utils/tracking';
import BlankPage from '@/components/Error/blank';
import { quizState } from '@/models/quizState';
import { QuizAlert, QuizAlertTypes } from '@/components/Alert';
import produce from 'immer';



export const DesktopPaper = () => {

    const navigate = useNavigate()

    const paper = useRecoilValue(paperState)

    const [quiz, setQuiz] = useRecoilState(quizState)

    if (quiz.questionList.length === 0) {
        return <BlankPage />
    }

    return (
        <LayoutDesktop>
            <div className='desktop-content-view'>
                <div className='desktop-paper-title'></div>
                <div className='desktop-paper-container'>
                    <PaperInfoComponent displayFlauntButton={false} />
                </div>
                <div className='desktop-paper-control'>
                    <div className='desktop-paper-control-left pointer' onClick={() => {
                        setQuiz(produce(quiz, (draftState) => {
                            draftState.alertType = QuizAlertTypes.HOME
                            draftState.alert = true
                        }));
                    }}></div>
                    <div className='desktop-paper-control-right pointer' onClick={() => {
                        Tracking.UP('click_all_answer_QuestionBank_share')
                        navigate(`/share/${paper.answer_log_id}/${quiz.questionnaire?.questionnaire_id ?? ''}/${Math.random()}`)
                    }}></div>
                </div>
            </div>
            {quiz.alert && <QuizAlert />}
        </LayoutDesktop>
    )

}


